var map = {
	"./bypass-grau.jpg": 3837,
	"./bypass-mansiche.jpg": 8413,
	"./centro-recreacional-la-rinconada.jpg": 9562,
	"./cesar-acuna-peralta-es-electo-gobernador-regional.jpg": 1938,
	"./colegio-juan-vasquez-jimenes-de-chepen.jpg": 8662,
	"./colegio-ramiro-nique-de-moche.jpg": 1541,
	"./complejo-deportivo-chanchan.jpg": 3644,
	"./compra-de-38-modernas-ambulancias-para-la-region-la-libertad.jpg": 6513,
	"./compra-de-nuevo-pool-de-maquinaria-para-region-la-libertad.jpg": 5200,
	"./compra-de-tomografo-de-ultima-generacion-para-el-hospital-regional-docentes.jpg": 3266,
	"./husares-de-junin.jpg": 6240,
	"./nuevo-centro-de-evaluacion-de-habilidades-en-la-conduccion.jpg": 5585,
	"./parque-turistico-cesar-vallejo.jpg": 3631,
	"./piscina-gildemeister.jpg": 8096,
	"./teatro-municipal.jpg": 7281,
	"./terminal-terrestre.jpg": 4709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;